<div class="row" style="margin-top:100px;margin-left:10px;">
    <div class="col-lg-3"></div>
    <div class="col-lg-6" style="vertical-align:central;">
        <h3>Your are not authorized. Kindly contact the syatem administrator.</h3>
        <span style="text-decoration: underline"><a (click)="Login()">Click here to go back.</a> </span>
    </div>
    <div class="col-lg-3"></div>
</div>